import React from 'react';
var Plus = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 100 100" },
        React.createElement("polygon", { fill: fill, points: "57.875 100 57.875 57.329 98.337 57.329 98.337 42.47 57.875 42.47 57.875 0 41.911 0 41.911 42.47 1.65 42.47 1.65 57.329 41.911 57.329 41.911 100" })));
};
export default Plus;
